import { render, staticRenderFns } from "./teamYJDetail.vue?vue&type=template&id=6a068557&scoped=true"
import script from "./teamYJDetail.vue?vue&type=script&lang=js"
export * from "./teamYJDetail.vue?vue&type=script&lang=js"
import style0 from "./teamYJDetail.vue?vue&type=style&index=0&id=6a068557&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"
import style1 from "./teamYJDetail.vue?vue&type=style&index=1&id=6a068557&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a068557",
  null
  
)

export default component.exports